import React, { useEffect, useContext, useRef } from 'react';
import formats from '../../controller/views/formats';
import Pedido from '../../controller/api/Pedido';
import user from '../../controller/api/User';
import { useState } from 'react';
import { Tab, Tabs, Button, Card, Modal, CardHeader, CardBody, ModalFooter, CardTitle, CardFooter } from 'react-bootstrap';
import { GetUserContext } from '../../Context/GetUserContext';
import Spinner from 'react-bootstrap/Spinner';
import { BsCheckSquareFill } from "react-icons/bs";
import { IoIosWarning } from "react-icons/io";
import { BsClockHistory } from "react-icons/bs";
import { LuCalendarClock } from "react-icons/lu";
import Company from '../../controller/api/Company';
import './OrdersOptions.css';
import SeachPagination from '../SeachPagination';

const OrdersOptions = () => {
    const { size, dataInicial, setDataInicial, dataFinal, setDataFinal, navegate, axiosConfig, setFetchTimestamp, fetchTimestamp } = useContext(GetUserContext)
    const [registroFinanceiro, setRegistroFinanceiro] = useState({});
    const [contentOrder, setContentOrder] = useState()
    const [prod, setProd] = useState([])
    const [statusConfirm, setStatusConfirm] = useState(0)
    const [allOrder, setAllOrder] = useState();
    const [showObsOrderContent, setShowObsOrderContent] = useState('');
    const [selectedTab, setSelectedTab] = useState(1);
    const [valorTotal, setValorTotal] = useState('')
    const [show, setShow] = useState(false);
    const [idPedido, setIdPedido] = useState('')
    const [loadOrder, setLoadOrder] = useState(false)
    const [fullscreen, setFullscreen] = useState(true);
    const [pedido, setPedido] = useState({});
    const [fileNF, setFileNF] = useState(null)

    const OrderApi = new Pedido()
    const User = new Company()
    const userDatasLog = JSON.parse(localStorage.getItem('user'))

    const handleSelect = (key) => {

        switch (key) {

            case 'Pendentes':

                setSelectedTab(1);
                setAllOrder({})
                setFetchTimestamp(Date.now())
                break;

            case 'Aprovados':
                setSelectedTab(2);
                setAllOrder({})
                setFetchTimestamp(Date.now())
                break;

            case 'Faturados':
                setSelectedTab(3);
                setAllOrder({})
                setFetchTimestamp(Date.now())
                break;

            case 'Enviado':
                setSelectedTab(4);
                setAllOrder({})
                setFetchTimestamp(Date.now())
                break;

            case 'Finalizados':
                setSelectedTab(5);
                setAllOrder({})
                setFetchTimestamp(Date.now())
                break;
            case 'Cancelados':
                setSelectedTab(0);
                setAllOrder({})
                setFetchTimestamp(Date.now())
                break;

            default:

                break;
        }
    };

    useEffect(() => {
        switch (selectedTab) {
            case 0:
                setLoadOrder(true)
                OrderApi.getAllOrderCancelado(userDatasLog?.Company_ID, axiosConfig)
                    .then((response) => {
                        if (response?.status == 401) {
                            setLoadOrder(false)
                        } else {
                            setAllOrder(response?.data?.response);
                            setLoadOrder(false)
                        }
                    })
                    .catch((err) => {
                        console.error("Erro ao carregar os pedidos:", err);
                    });
                break;

            case 1:
                setLoadOrder(true)
                OrderApi.getAllOrder(userDatasLog?.Company_ID, dataInicial, dataFinal, axiosConfig)
                    .then((response) => {
                        if (response?.status == 401) {
                            setLoadOrder(false)
                        } else {
                            setAllOrder(response?.data?.response);
                            setLoadOrder(false)
                        }
                    })
                    .catch((err) => {
                        console.error("Erro ao carregar os pedidos:", err);
                    });
                break;

            case 2:
                setLoadOrder(true)

                OrderApi.getAllOrderAprovad(userDatasLog?.Company_ID, dataInicial, dataFinal, axiosConfig)
                    .then((response) => {
                        if (response?.status == 401) {
                            setLoadOrder(false)
                        } else {
                            setAllOrder(response?.data?.response);
                            setLoadOrder(false)
                        }
                    })
                    .catch((err) => {
                        console.error("Erro ao carregar os pedidos:", err);
                    });
                break;

            case 3:
                setLoadOrder(true)
                OrderApi.getAllOrderFatured(userDatasLog?.Company_ID, dataInicial, dataFinal, axiosConfig)
                    .then((response) => {
                        if (response?.status == 401) {

                            setLoadOrder(false)
                        } else {
                            setAllOrder(response?.data?.response);
                            setLoadOrder(false)
                        }
                    })
                    .catch((err) => {
                        console.error("Erro ao carregar os pedidos:", err);
                    });
                break;
            case 4:
                setLoadOrder(true)
                OrderApi.getAllOrderEnviado(userDatasLog?.Company_ID, dataInicial, dataFinal, axiosConfig)
                    .then((response) => {
                        if (response?.status == 401) {

                            setLoadOrder(false)
                        } else {
                            setAllOrder(response?.data?.response);
                            setLoadOrder(false)
                        }
                    })
                    .catch((err) => {
                        console.error("Erro ao carregar os pedidos:", err);
                    });
                break;

            case 5:
                setLoadOrder(true)
                OrderApi.getAllOrderFinalizado(userDatasLog?.Company_ID, dataInicial, dataFinal, axiosConfig)
                    .then((response) => {
                        if (response?.status == 401) {

                            setLoadOrder(false)
                        } else {

                            setAllOrder(response?.data?.response);
                            setLoadOrder(false)
                        }
                    })
                    .catch((err) => {
                        console.error("Erro ao carregar os pedidos:", err);
                    });
                break;


            default:
                break;
        }


    }, [fetchTimestamp, selectedTab]);

    const handleTogleDetails = (e) => {

        setIdPedido(e?.ID_Pedido)
        setShow(true);
        setFullscreen(e);
        setContentOrder(e);
        setStatusConfirm(0);
        setRegistroFinanceiro(e?.Registro_Financeiro);
        setPedido(e);



        if (e?.Pedidos_Produtos_Estoques) {
            const newArrayProd = [];
            e.Pedidos_Produtos_Estoques.forEach(as => {

                if (as?.Produtos_Estoques) {
                    as.Produtos_Estoques.forEach(pe => {
                        if (pe?.Produtos?.[0]) {
                            const produtoComQuantidade = {
                                ...pe.Produtos[0],
                                quantidade: as.Estoque_Pedido
                            };
                            newArrayProd.push(produtoComQuantidade);
                        }
                    });
                }
            });
            setValorTotal(e.Valor)
            setProd(newArrayProd);


        }
    };
    const handleClose = () => {
        setShow(false);
        setFileNF(null)
    }

    const handleDownload = (id, nome) => {
        User.download(id, nome)
    };

    useEffect(() => {
        allOrder?.rows?.map(item => {
            setContentOrder(item)
        })
    }, [allOrder])

    return (
        <>
            {
                size?.categoria !== 'xlarge' && size?.categoria !== 'large' ?
                    (
                        <Card className='h-100'>
                            <CardHeader className='text-center'>
                                <CardTitle>Pedidos</CardTitle>
                            </CardHeader>

                            <Card.Body >
                                <SeachPagination currentPage={'order'} Company_ID={userDatasLog?.Company_ID} />

                                <Tabs
                                    defaultActiveKey={navegate?.tabs?.[0]?.tab}
                                    id="uncontrolled-tab-example"
                                    className="mb-3 custom-tabs"
                                    onSelect={handleSelect}
                                >

                                    {
                                        navegate?.tabs?.map((tabs, index) => (
                                            <Tab disabled={loadOrder} key={index} eventKey={tabs?.tab} title={tabs?.tab}>


                                                {
                                                    loadOrder ?
                                                        (<div className='d-flex align-items-center '><div className='custom-spinner'><Spinner animation="border" /></div>Carregando... </div>) :
                                                        (
                                                            allOrder?.rows?.map((item, index) => (
                                                                <React.Fragment key={index}>
                                                                    <div className='area-side-order' onClick={() => { handleTogleDetails(item) }}>
                                                                        <div className='side-order'><div>N° Pedido: </div> <span>#{item?.ID_Pedido}</span></div>
                                                                        <div className='side-order'><div>Data Pedido: </div> <span>{`${item?.Pedido_Feito} - ${item?.Pedido_Feito_Hora}`}</span></div>
                                                                        <div className='side-order'><div>Comprador: </div> <span>{item?.company?.users?.[0]?.Name}</span></div>
                                                                        <div className='side-order'><div>Empresa: </div> <span>{item?.company?.Corporate_Name}</span></div>
                                                                        <div className='side-order'><div>Distribuidora: </div> <span>Auparts - Distribuidora</span></div>
                                                                        <div className='side-order'><div>Valor Total: </div> <span> R$ {formats.formatPrice(item?.Valor)}</span></div>
                                                                        <div style={{ border: "transparent" }} className='side-order '>Nota Fiscal: <div>
                                                                            {item?.nota_fiscal_companies?.length === 0 ?
                                                                                <div style={{ marginLeft: "5px" }} className='d-flex pl-1 align-items-center justify-content-center '>
                                                                                    <div style={{ color: "gray" }}> Aguardando...</div>
                                                                                </div>
                                                                                :

                                                                                <div style={{ marginLeft: "5px", color: "gray" }}>Disponivel</div>

                                                                            }
                                                                        </div>
                                                                        </div>
                                                                    </div>
                                                                    <br></br>
                                                                </React.Fragment>


                                                            ))
                                                        )
                                                }



                                            </Tab>
                                        ))
                                    }
                                </Tabs>

                                <Modal show={show}
                                    size="lg"
                                    aria-labelledby="contained-modal-title-vcenter"
                                    centered
                                    fullscreen
                                    onHide={handleClose}  >

                                    <Modal.Header closeButton>
                                        <h5>Pedido: {contentOrder?.Pedido_Feito} -    {`${contentOrder?.Pedido_Feito_Hora}hs`}</h5>
                                    </Modal.Header>

                                    <Modal.Body>
                                        <div className='modal-content-mai-left'>
                                            <div className='area-itens-left-top '>
                                                <Card className='card-menor'>
                                                    <CardHeader><h6>Dados da Empresa</h6></CardHeader>
                                                    <CardBody>
                                                        <div>
                                                            <div className='item-card-body-details'>
                                                                <div>Empresa: <span className='text-secondary'>{contentOrder?.company?.Corporate_Name}</span></div>
                                                                <div>CNPJ:  <span className='text-secondary'>{formats.formatarCNPJ(contentOrder?.company?.CNPJ)}</span></div>
                                                                <div>Telefone:  <span className='text-secondary'>{formats.formatTelefoneFixo(contentOrder?.company?.Landline)}</span></div>
                                                            </div>
                                                            <div className='item-card-body-details'>
                                                                <div>Email:  <span className='text-secondary'>{contentOrder?.company?.Email}</span></div>
                                                                <div>Comprador: <span className='text-secondary'>{contentOrder?.company?.users?.[0]?.Name}</span></div>
                                                            </div>
                                                        </div>

                                                        <div className='item-card-body-details'>
                                                            <hr></hr>
                                                            {contentOrder?.Tipo_Pedido == 1 ? (<h6 className='text-secondary'>Endereço de Retirada:</h6>) : (<h6 className='text-secondary'>Endereço de Entrega:</h6>)}
                                                            {contentOrder?.Tipo_Pedido == 1 ? (<div>{contentOrder?.Endereco}</div>) :
                                                                (<>
                                                                    <div>{`${contentOrder?.company?.address?.Name}, ${contentOrder?.company?.address?.Number} - ${contentOrder?.company?.address?.neighborhood?.Name}, ${contentOrder?.company?.address?.city?.Name} - ${contentOrder?.company?.address?.state?.Uf}, ${contentOrder?.company?.address?.Cep}`}</div>
                                                                    {contentOrder?.Observacao?.length == 0 ? (<></>) : (<div><strong className='text-secondary'>Observação:</strong> {contentOrder?.Observacao}</div>)}
                                                                </>)
                                                            }
                                                        </div>

                                                    </CardBody>
                                                </Card>
                                                <br></br>
                                            </div>



                                            <Card className='modal-content-main-right'>
                                                <CardHeader><h6>Acompanhamento Pedido</h6></CardHeader>
                                                <CardBody>
                                                    {
                                                        pedido?.Aprovado === null ?
                                                            (<div>
                                                                <div>Forma de pagamento:</div>
                                                                <div className='d-flex justify-content-between'>
                                                                    {registroFinanceiro?.Forma_de_Pagamento?.Pagamento === "PIX" ?
                                                                        (<div>{registroFinanceiro?.Forma_de_Pagamento?.Pagamento}</div>)
                                                                        :
                                                                        (<>
                                                                            {
                                                                                registroFinanceiro?.Forma_de_Pagamento?.Pagamento === 'Dinheiro' ?
                                                                                    (<div>{registroFinanceiro?.Forma_de_Pagamento?.Pagamento}</div>)
                                                                                    :
                                                                                    (<>
                                                                                        <div>{registroFinanceiro?.Forma_de_Pagamento?.Pagamento}</div>
                                                                                        <div>{`${registroFinanceiro?.Parcela}x de R$ ${formats.formatPrice(registroFinanceiro?.Valor_Parcela)}`}</div>
                                                                                    </>)
                                                                            }
                                                                        </>)
                                                                    }
                                                                </div>
                                                                <div className='d-flex justify-content-between'>
                                                                    <div>Valor Total: </div><div> {`R$ ${formats.formatPrice(registroFinanceiro?.Valor_Total)}`} </div>
                                                                </div>

                                                            </div>)
                                                            :
                                                            (<>
                                                                <div>
                                                                    <div>Forma de pagamento:</div>
                                                                    <div className='d-flex justify-content-between'>
                                                                        {registroFinanceiro?.Forma_de_Pagamento?.Pagamento === "PIX" ?
                                                                            (<div>{registroFinanceiro?.Forma_de_Pagamento?.Pagamento}</div>)
                                                                            :
                                                                            (<>
                                                                                {
                                                                                    registroFinanceiro?.Forma_de_Pagamento?.Pagamento === 'Dinheiro' ?
                                                                                        (<div>{registroFinanceiro?.Forma_de_Pagamento?.Pagamento}</div>)
                                                                                        :
                                                                                        (<>
                                                                                            <div>{registroFinanceiro?.Forma_de_Pagamento?.Pagamento}</div>
                                                                                            <div>{`${registroFinanceiro?.Parcela}x de R$ ${formats.formatPrice(registroFinanceiro?.Valor_Parcela)}`}</div>
                                                                                        </>)
                                                                                }
                                                                            </>)
                                                                        }
                                                                    </div>
                                                                    {
                                                                        contentOrder?.nota_fiscal_companies?.length === 0 ?
                                                                            (<></>)
                                                                            :
                                                                            (<div>Nota Fiscal</div>)
                                                                    }
                                                                    {
                                                                        contentOrder?.nota_fiscal_companies?.map((nf, index) => (
                                                                            <React.Fragment key={index}>
                                                                                <div className=' form-control table-nf' onClick={() => handleDownload(nf?.nota_fiscal?.ID_nota_fiscal, nf?.nota_fiscal?.Nome)}> {nf?.nota_fiscal?.Nome} </div>
                                                                            </React.Fragment>
                                                                        ))
                                                                    }
                                                                    <div className='d-flex justify-content-between'>
                                                                        <div>Valor Total: </div><div> {`R$ ${formats.formatPrice(registroFinanceiro?.Valor_Total)}`} </div>
                                                                    </div>
                                                                </div>

                                                            </>)
                                                    }

                                                    {
                                                        statusConfirm == 2 &&
                                                        <>
                                                            <hr></hr>
                                                            <textarea maxLength={100} value={showObsOrderContent} onChange={(e) => { setShowObsOrderContent(e.target.value) }} className='form-control h-25' autoFocus placeholder="Informe o motivo do cancelamento. "></textarea>
                                                            <div className='d-flex justify-content-between'>
                                                                <div></div>
                                                                <div>{showObsOrderContent?.length}/100</div>
                                                            </div>
                                                        </>
                                                    }
                                                </CardBody>
                                            </Card>
                                            <br></br>
                                            <Card>
                                                <CardHeader><h6>Status do Pedido</h6></CardHeader>
                                                <CardBody>
                                                    {
                                                        contentOrder?.Cancelado_adm !== null ?
                                                            (<div className='form-control'>
                                                                <div><strong className='text-secondary'>{contentOrder?.Cancelado_adm}</strong></div>
                                                                <div>{contentOrder?.Cancelado_adm_obs}</div>
                                                            </div>)
                                                            :
                                                            (<>
                                                                <div className='d-flex align-items-center'>
                                                                    <div>Pedido Feito</div>
                                                                    <div className="flex-dotted-line mx-2"></div>
                                                                    <div>{`${pedido?.Pedido_Feito} - ${pedido?.Pedido_Feito_Hora}`}</div>
                                                                </div>

                                                                <div className='d-flex align-items-center'>
                                                                    <div>Aprovado</div>
                                                                    <div className="flex-dotted-line mx-2"></div>
                                                                    <div>
                                                                        {
                                                                            pedido?.Aprovado === null ?
                                                                                (<></>) : (<> {`${pedido?.Aprovado} - ${pedido?.Aprovado_Hora}`}</>)
                                                                        }

                                                                    </div>
                                                                </div>

                                                                <div className='d-flex align-items-center'>
                                                                    <div>Faturado</div>
                                                                    <div className="flex-dotted-line mx-2"></div>
                                                                    <div>
                                                                        {
                                                                            pedido?.Faturado === null ?
                                                                                (<></>)
                                                                                :
                                                                                (<>{`${pedido?.Faturado} - ${pedido?.Faturado_Hora}`}</>)
                                                                        }
                                                                    </div>
                                                                </div>

                                                                <div className='d-flex align-items-center'>
                                                                    <div>Enviado</div>
                                                                    <div className="flex-dotted-line mx-2"></div>
                                                                    <div>
                                                                        {
                                                                            pedido?.Enviado === null ?
                                                                                (pedido?.Faturado !== null && <></>)
                                                                                :
                                                                                (<>{`${pedido?.Enviado} - ${pedido?.Enviado_Hora}`}</>)
                                                                        }

                                                                    </div>
                                                                </div>

                                                                <div className='d-flex align-items-center'>
                                                                    <div>Entregue</div>
                                                                    <div className="flex-dotted-line mx-2"></div>
                                                                    <div>
                                                                        {
                                                                            pedido?.Entregue === null ?
                                                                                (pedido?.Enviado !== null && <BsClockHistory />)
                                                                                :
                                                                                (<>{`${pedido?.Entregue} - ${pedido?.Entregue_Hora}`}</>)
                                                                        }
                                                                    </div>
                                                                </div>


                                                            </>)
                                                    }

                                                </CardBody>
                                            </Card>

                                            <br></br>
                                            <div className='area-itens-left-bottom'>
                                                <Card className='card-details-order-down'>
                                                    <CardHeader className='d-flex align-items-center justify-content-between' ><h6>Itens Comprados</h6></CardHeader>
                                                    <CardBody className='area-card-details-product'>
                                                        {
                                                            prod?.map((produto, index) => (
                                                                <div className='mb-2' key={index}>
                                                                    <div>Produto: <span className='text-secondary'>{produto?.Nome_Produto}</span></div>
                                                                    <div>Fabricante: <span className='text-secondary'>{produto?.Fabricante?.Nome_Fabricante}</span></div>
                                                                    <div>QTD: <span className='text-secondary'>{produto?.quantidade}</span></div>
                                                                    <div>Preço: <span className='text-secondary'>{`R$ ${formats.formatPrice(produto?.Preco_4)}`}</span></div>
                                                                    <hr></hr>
                                                                </div>

                                                            ))
                                                        }
                                                    </CardBody>
                                                </Card>
                                            </div>
                                        </div>
                                    </Modal.Body>
                                </Modal>
                            </Card.Body>
                        </Card >
                    )
                    :
                    (
                        <Card className='h-100'>


                            <Card.Body >
                                <SeachPagination currentPage={'order'} Company_ID={userDatasLog?.Company_ID} />

                                <Tabs
                                    defaultActiveKey={navegate?.tabs?.[0]?.tab}
                                    id="uncontrolled-tab-example"
                                    className="mb-3 custom-tabs"
                                    onSelect={handleSelect}
                                >

                                    {
                                        navegate?.tabs?.map((tabs, index) => (
                                            <Tab className="table-custom-fin" disabled={loadOrder} key={index} eventKey={tabs?.tab} title={tabs?.tab}>
                                                <>
                                                    <table className="table-hol table table-hover">
                                                        <thead>
                                                            <tr>
                                                                <th scope="col">N° Pedido</th>
                                                                <th scope="col">Data do Pedido</th>
                                                                <th scope="col">Comprador</th>
                                                                <th scope="col">Empresa</th>
                                                                <th scope="col">Canal de Vendas</th>
                                                                <th scope="col">Valor Total</th>
                                                                <th scope="col" className='text-center'>Nota Fiscal</th>
                                                            </tr>
                                                        </thead>
                                                        {
                                                            <tbody>
                                                                {
                                                                    loadOrder ?
                                                                        (<tr><td className='d-flex align-items-center '><div className='custom-spinner'><Spinner animation="border" /></div>Carregando... </td></tr>) :
                                                                        (
                                                                            allOrder?.rows?.map((item, index) => (
                                                                                <tr style={{ cursor: "pointer" }} key={index} onClick={() => { handleTogleDetails(item) }}>
                                                                                    <td>#{item?.ID_Pedido}</td>
                                                                                    <td>{`${item?.Pedido_Feito} - ${item?.Pedido_Feito_Hora}`}</td>
                                                                                    <td>{item?.company?.users?.[0]?.Name}</td>
                                                                                    <td>{item?.company?.Corporate_Name}</td>
                                                                                    <td>Auparts - Distribuidora</td>
                                                                                    <td> R$ {formats.formatPrice(item?.Valor)}</td>
                                                                                    {item?.nota_fiscal_companies?.length === 0 ? <td className='d-flex  align-items-center justify-content-center bg-danger-edit'><div>Sem NF</div> <IoIosWarning style={{ marginLeft: "5px" }} /></td> : <td className='d-flex  align-items-center justify-content-center bg-success-edit'><div>NF</div> <BsCheckSquareFill style={{ marginLeft: "5px" }} /></td>}
                                                                                </tr>
                                                                            ))
                                                                        )
                                                                }
                                                            </tbody>
                                                        }
                                                    </table>
                                                </>
                                            </Tab>
                                        ))
                                    }
                                </Tabs>

                                <Modal show={show}
                                    size="lg"
                                    aria-labelledby="contained-modal-title-vcenter"
                                    centered
                                    fullscreen={fullscreen}
                                    onHide={handleClose}  >

                                    <Modal.Header closeButton>
                                        <Modal.Title>
                                            <div className='d-flex align-items-center'>
                                                <div style={{ marginRight: "10px" }}>Detalhes do Pedido:</div>

                                                <div className='d-flex align-items-center'>
                                                    <LuCalendarClock style={{ marginRight: "5px" }} />
                                                    {contentOrder?.Pedido_Feito}
                                                </div>
                                                <div style={{ marginLeft: "5px", marginRight: "5px" }}>-</div>
                                                <div className='d-flex align-items-center'>
                                                    <BsClockHistory style={{ marginRight: "5px" }} />
                                                    {`${contentOrder?.Pedido_Feito_Hora}hs`}
                                                </div>
                                            </div>


                                        </Modal.Title>
                                    </Modal.Header>

                                    <Modal.Body className=' d-flex justify-content-between body-modal-order'>
                                        <div className='modal-content-mai-left'>

                                            <div className='area-itens-left-top '>
                                                <Card className='card-menor'>
                                                    <CardHeader><h6>Dados da Empresa</h6></CardHeader>
                                                    <CardBody >
                                                        <div className='area-datas-order'>
                                                            <div className='item-card-body-details'>
                                                                <div>Empresa: <strong className='text-secondary'>{contentOrder?.company?.Corporate_Name}</strong></div>
                                                                <div>CNPJ:  <strong className='text-secondary'>{formats.formatarCNPJ(contentOrder?.company?.CNPJ)}</strong></div>
                                                                <div>Telefone:  <strong className='text-secondary'>{formats.formatTelefoneFixo(contentOrder?.company?.Landline)}</strong></div>
                                                            </div>
                                                            <div className='item-card-body-details'>
                                                                <div>Email:  <strong className='text-secondary'>{contentOrder?.company?.Email}</strong></div>
                                                                <div>Comprador: <strong className='text-secondary'>{contentOrder?.company?.users?.[0]?.Name}</strong></div>
                                                                <div>Valor Total:  <strong className='text-secondary'> R$ {formats.formatPrice(contentOrder?.Valor)}</strong></div>
                                                            </div>
                                                        </div>

                                                        <div className='item-card-body-details'>
                                                            <hr></hr>
                                                            {contentOrder?.Tipo_Pedido == 1 ? (<h6 className='text-secondary'>Endereço de Retirada:</h6>) : (<h6 className='text-secondary'>Endereço de Entrega:</h6>)}
                                                            {contentOrder?.Tipo_Pedido == 1 ? (<div>{contentOrder?.Endereco}</div>) :
                                                                (<>
                                                                    <div>{`${contentOrder?.company?.address?.Name}, ${contentOrder?.company?.address?.Number} - ${contentOrder?.company?.address?.neighborhood?.Name}, ${contentOrder?.company?.address?.city?.Name} - ${contentOrder?.company?.address?.state?.Uf}, ${contentOrder?.company?.address?.Cep}`}</div>
                                                                    {contentOrder?.Observacao?.length == 0 ? (<></>) : (<div><strong className='text-secondary'>Observação:</strong> {contentOrder?.Observacao}</div>)}
                                                                </>)
                                                            }
                                                        </div>
                                                    </CardBody>
                                                </Card>
                                            </div>

                                            <div className='area-itens-left-bottom'>
                                                <Card className='card-details-order-down'>
                                                    <CardHeader className='d-flex align-items-center justify-content-between' ><h6>Itens Comprados</h6><h6>Total: {`R$ ${formats.formatPrice(valorTotal)}`}</h6></CardHeader>
                                                    <CardBody className='area-card-details-product'>
                                                        <div></div>
                                                        <table className="table body-product-details">
                                                            <thead>
                                                                <tr>
                                                                    <th scope="col">#</th>
                                                                    <th scope="col">Produto</th>
                                                                    <th scope="col">Fabricante</th>
                                                                    <th scope="col">QTD</th>
                                                                    <th scope="col">Valor</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {
                                                                    prod?.map((produto, index) => (
                                                                        <tr key={index}>
                                                                            <th scope="row">{index + 1}</th>
                                                                            <td>{produto?.Nome_Produto}</td>
                                                                            <td>{produto?.Fabricante?.Nome_Fabricante}</td>
                                                                            <td>{produto?.quantidade}</td>
                                                                            <td>{`R$ ${formats.formatPrice(produto?.Preco_4)}`}</td>
                                                                        </tr>
                                                                    ))
                                                                }
                                                            </tbody>
                                                        </table>
                                                    </CardBody>
                                                </Card>
                                            </div>
                                        </div>

                                        <Card className='modal-content-main-right'>
                                            <CardHeader><h6>Acompanhamento Pedido</h6></CardHeader>
                                            <CardBody>
                                                {
                                                    pedido?.Aprovado === null ?
                                                        (<>
                                                            <table className="table">
                                                                <thead>
                                                                    <tr>
                                                                        <th scope="col">Forma de Pagamento</th>
                                                                        {
                                                                            registroFinanceiro?.Forma_de_Pagamento?.Pagamento === "PIX" ?
                                                                                (<></>)
                                                                                :
                                                                                (<>
                                                                                    {
                                                                                        registroFinanceiro?.Forma_de_Pagamento?.Pagamento !== 'Dinheiro' ?
                                                                                            (<><th scope="col">Parcela</th></>) : (<></>)
                                                                                    }
                                                                                </>)
                                                                        }

                                                                        <th scope="col">Valor Total</th>
                                                                    </tr>
                                                                </thead>

                                                                <tbody>
                                                                    <tr>
                                                                        {registroFinanceiro?.Forma_de_Pagamento?.Pagamento === "PIX" ?
                                                                            (<td>{registroFinanceiro?.Forma_de_Pagamento?.Pagamento}</td>)
                                                                            :
                                                                            (<>
                                                                                {
                                                                                    registroFinanceiro?.Forma_de_Pagamento?.Pagamento === 'Dinheiro' ?
                                                                                        (<>
                                                                                            <td>{registroFinanceiro?.Forma_de_Pagamento?.Pagamento}</td>
                                                                                        </>)
                                                                                        :
                                                                                        (<>
                                                                                            <td>{registroFinanceiro?.Forma_de_Pagamento?.Pagamento}</td>
                                                                                            <td>{`${registroFinanceiro?.Parcela}x de R$ ${formats.formatPrice(registroFinanceiro?.Valor_Parcela)}`}</td>
                                                                                        </>)
                                                                                }
                                                                            </>)
                                                                        }
                                                                        <td>{`R$ ${formats.formatPrice(registroFinanceiro?.Valor_Total)}`}</td>
                                                                    </tr>
                                                                </tbody>

                                                            </table>



                                                        </>)
                                                        :
                                                        (<>
                                                            <table className="table">
                                                                <thead>
                                                                    <tr>
                                                                        <th scope="col">Forma de Pagamento</th>
                                                                        <th scope="col">Parcela</th>
                                                                        <th scope="col">Valor Total</th>
                                                                    </tr>
                                                                </thead>

                                                                <tbody>
                                                                    <tr>
                                                                        <td>{registroFinanceiro?.Forma_de_Pagamento?.Pagamento}</td>
                                                                        <td>{`${registroFinanceiro?.Parcela}x de R$ ${formats.formatPrice(registroFinanceiro?.Valor_Parcela)}`}</td>
                                                                        <td>{`R$ ${formats.formatPrice(registroFinanceiro?.Valor_Total)}`}</td>
                                                                        {
                                                                            fileNF === null ?
                                                                                (<td></td>) :
                                                                                (<td className='bg-confim-table'><button className='btn btn-outline-success'>Enviar</button></td>)
                                                                        }
                                                                    </tr>
                                                                </tbody>
                                                            </table>



                                                            <table className=' border table table-nf-main table-hover table-bordered'>
                                                                <thead>
                                                                    {
                                                                        contentOrder?.nota_fiscal_companies?.length === 0 ?
                                                                            (<tr></tr>)
                                                                            :
                                                                            (<tr><th scope="col">Nota Fiscal</th></tr>)
                                                                    }

                                                                </thead>
                                                                {
                                                                    contentOrder?.nota_fiscal_companies?.map((nf, index) => (
                                                                        <React.Fragment key={index}>
                                                                            <tbody>
                                                                                <tr>
                                                                                    <td className=' table-nf' onClick={() => handleDownload(nf?.nota_fiscal?.ID_nota_fiscal, nf?.nota_fiscal?.Nome)}> {nf?.nota_fiscal?.Nome} </td>
                                                                                </tr>
                                                                            </tbody>
                                                                        </React.Fragment>
                                                                    ))
                                                                }
                                                            </table>
                                                            <br></br>
                                                            <h6>Atualização do Pedido</h6>
                                                            <hr></hr>

                                                            {
                                                                contentOrder?.Cancelado_adm !== null ?
                                                                    (<div className='form-control'>
                                                                        <div><strong className='text-secondary'>{contentOrder?.Cancelado_adm}</strong></div>
                                                                        <div>{contentOrder?.Cancelado_adm_obs}</div>
                                                                    </div>)
                                                                    :
                                                                    (<table className="table table-bordered">
                                                                        <thead>
                                                                            <tr>
                                                                                <th scope="col" className='text-center'>Pedido Feito</th>
                                                                                <th scope="col" className='text-center'>Aprovado</th>
                                                                                <th scope="col" className='text-center'>Faturado</th>
                                                                                <th scope="col" className='text-center'>Enviado</th>
                                                                                <th scope="col" className='text-center'>Entregue</th>
                                                                            </tr>
                                                                        </thead>


                                                                        <tbody>
                                                                            <tr>
                                                                                <td className='text-center'>{`${pedido?.Pedido_Feito} - ${pedido?.Pedido_Feito_Hora}`}</td>
                                                                                <td className='text-center'>{`${pedido?.Aprovado} - ${pedido?.Aprovado_Hora}`}</td>
                                                                                <td className='text-center'>
                                                                                    {
                                                                                        pedido?.Aprovado !== null && pedido?.Faturado === null ?
                                                                                            (<BsClockHistory />)
                                                                                            :
                                                                                            (<>{`${pedido?.Faturado} - ${pedido?.Faturado_Hora}`}</>)
                                                                                    }
                                                                                </td>

                                                                                <td className='text-center'>
                                                                                    {
                                                                                        pedido?.Enviado === null ?
                                                                                            (pedido?.Faturado !== null && <BsClockHistory />)
                                                                                            :
                                                                                            (<>{`${pedido?.Enviado} - ${pedido?.Enviado_Hora}`}</>)
                                                                                    }
                                                                                </td>
                                                                                <td className='text-center'>
                                                                                    {
                                                                                        pedido?.Entregue === null ?
                                                                                            (pedido?.Enviado !== null && <BsClockHistory />)
                                                                                            :
                                                                                            (<>{`${pedido?.Entregue} - ${pedido?.Entregue_Hora}`}</>)
                                                                                    }
                                                                                </td>
                                                                            </tr>
                                                                        </tbody>
                                                                    </table>)
                                                            }

                                                        </>)
                                                }

                                                {
                                                    statusConfirm == 2 &&
                                                    <>
                                                        <hr></hr>
                                                        <textarea maxLength={100} value={showObsOrderContent} onChange={(e) => { setShowObsOrderContent(e.target.value) }} className='form-control h-25' autoFocus placeholder="Informe o motivo do cancelamento. "></textarea>
                                                        <div className='d-flex justify-content-between'>
                                                            <div></div>
                                                            <div>{showObsOrderContent?.length}/100</div>
                                                        </div>
                                                    </>
                                                }
                                            </CardBody>
                                        </Card>

                                    </Modal.Body>
                                </Modal>
                            </Card.Body>
                        </Card >
                    )
            }

        </>
    )
}


export default OrdersOptions